import { useDispatch } from "react-redux"
import { setActiveSize } from "../../../Features/inventoryManagementSlice";

function ProductSizeBox({size, isActive}) {
    const dispatch = useDispatch();

    function handleSizeClick() {
        dispatch(setActiveSize(size));
    }

    return (
        <div onClick={handleSizeClick} className={`cursor-pointer rounded-lg px-4 py-2 border border-[#EAEAEA] ${isActive ? 'bg-link' : 'bg-primaryColor hover:bg-primaryAccent'}`}>
            <p className='text-[14px] leading-[26px] text-buttonText'>{size}</p>
        </div>
    )
}

export default ProductSizeBox;
